import React from "react";
import { NavLink } from "react-router-dom";
import { classNames } from "Utils/utils";
import { isPlatformNavItemActive } from "Constants/Navigations/superAdminNavigation.utils";

const platformNavLinkClass = ({ isActive, collapsed, onGradient }) => {
  if (!onGradient) {
    return classNames(
      "group flex items-center rounded-md px-2 py-2 text-sm font-medium",
      collapsed ? "justify-center" : "",
      isActive
        ? "bg-gray-100 text-gray-900"
        : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
    );
  }

  return classNames(
    "platform-admin-nav-item--gradient group flex items-center rounded-md px-2 py-2 text-sm font-medium transition-colors",
    collapsed ? "justify-center" : "",
    isActive ? "is-active" : "navLink-title"
  );
};

const PlatformAdminNavItem = ({ item, pathname, collapsed, onGradient }) => {
  const isActive = isPlatformNavItemActive(item, pathname);

  return (
    <NavLink
      to={item.to}
      title={collapsed ? item.name : undefined}
      className={platformNavLinkClass({ isActive, collapsed, onGradient })}
    >
      <item.icon
        className={classNames(
          "platform-admin-nav-icon flex-shrink-0",
          collapsed ? "h-6 w-6" : "mr-3 h-6 w-6",
          onGradient
            ? isActive
              ? "text-white"
              : "navLink-title opacity-90"
            : "text-gray-400 group-hover:text-gray-500"
        )}
        aria-hidden="true"
      />
      {!collapsed ? <span className="truncate">{item.name}</span> : null}
    </NavLink>
  );
};

export const PlatformAdminSidebarNav = ({
  sections,
  pathname,
  collapsed = false,
  onGradient = true,
  className,
}) => (
  <div className={className}>
    {sections.map((section, sectionIndex) => (
      <div
        key={section.id}
        className={classNames(sectionIndex > 0 ? "mt-4" : "", collapsed ? "space-y-1" : "")}
      >
        {!collapsed ? (
          <p
            className={classNames(
              "mb-2 px-2 text-[11px] font-semibold uppercase tracking-wider",
              onGradient ? "platform-admin-nav-section" : "text-gray-500"
            )}
          >
            {section.label}
          </p>
        ) : sectionIndex > 0 ? (
          <div
            className={classNames(
              "mx-2 my-2 border-t",
              onGradient ? "border-white/25" : "border-gray-200"
            )}
            aria-hidden="true"
          />
        ) : null}
        <div className="space-y-0.5">
          {section.items.map((item) => (
            <PlatformAdminNavItem
              key={item.to}
              item={item}
              pathname={pathname}
              collapsed={collapsed}
              onGradient={onGradient}
            />
          ))}
        </div>
      </div>
    ))}
  </div>
);

export default PlatformAdminSidebarNav;
